import React, { useContext } from "react";

import { Button } from "antd";

import { AppContext } from "../AppContext";

import { signOut } from "../utils/common";
import { hasAnyTabPermission, getDefaultRoute } from "../utils/Permissions";

import logout from "../actions/logout";

import maintenanceImg from "../assets/images/under_maintenance.gif";

import "./UnderMaintenance.css";

const UnderMaintenance = ({ history }) => {
  const appContext = useContext(AppContext);
  const navigateToHome = () => {
    history.push(getDefaultRoute());
    window.location.reload(false);
  };
  return (
    <div className="UnderMaintenanceContainer">
      <div className="">
        <img src={maintenanceImg} alt="under_maintenance" width={450} />
      </div>
      <div className="UnderMaintenance__ContentContainer">
        <h3 className="UnderMaintenance__ContentContainer__h3">
          A ninja stole this page.
        </h3>
        <h6>
          Check back later!!
          {!hasAnyTabPermission() && " (No Permissions)"}
        </h6>
        <div className="UnderMaintenance__Buttons">
          <Button
            type="default"
            className="UnderMaintenance__SignOutButton"
            onClick={() => navigateToHome()}
          >
            Back To Home
          </Button>
          <Button
            type="primary"
            className="UnderMaintenance__SignOutButton"
            onClick={async () => {
              // Call logout API first before clearing credentials
              await logout()
                .catch(() => {
                  // Silently handle any errors - frontend logout proceeds regardless
                })
                .finally(() => {
                  // Always call signOut regardless of logout API success/failure
                  signOut(history, appContext);
                });
            }}
          >
            Sign Out
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UnderMaintenance;
